<template>
  <div class="lang-selector">
    <div class="dropdown" @click="toggleDropdown">
      <span v-if="selectedLang">
        <img :src="selectedLang.flag" class="flag" alt="" />
        {{ selectedLang.name }}
      </span>
      <span v-else>🌐 Select Language</span>
    </div>
    
    <ul v-if="open" class="dropdown-list">
      <li
        v-for="lang in languages"
        :key="lang.code"
        @click="setLanguage(lang)"
      >
        <img :src="lang.flag" class="flag" alt="" />
        {{ lang.name }}
      </li>
    </ul>
    
   </div>
</template>

<script>
export default {
  data() {
    return {
      languages: [],
      selectedLang: null,
      open: false,
      translateReady: false,
    };
  },
   mounted() {
    this.loadLanguages();
    
    // Subscribe to language changes from other components
    this.unsubscribe = this.$translator.onLanguageChange((langCode) => {
      this.syncLanguage(langCode);
    });
  },
  
  beforeDestroy() {
    // Cleanup subscription
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  
  methods: {
    async loadLanguages() {
      const res = await fetch("/languages.json");
      this.languages = await res.json();
      
      // Get current language from translator
      const currentCode = this.$translator.getCurrentLanguage();
      this.selectedLang = this.languages.find(l => l.code === currentCode) || 
                          this.languages.find(l => l.code === 'en');
    },
    
    toggleDropdown() {
      this.open = !this.open;
    },
    
    setLanguage(lang) {
      this.selectedLang = lang;
      this.open = false;
      
      // Use centralized translator
      this.$translator.setLanguage(lang.code);
    },
    
    syncLanguage(langCode) {
      // Update UI when language changes from elsewhere
      this.selectedLang = this.languages.find(l => l.code === langCode);
    }
  },
};
</script>

<style scoped>
.lang-selector {
  position: relative;
  width: 200px;
  cursor: pointer;
  font-family: Arial, sans-serif;
}

.dropdown {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
}

.dropdown:hover {
  border-color: #888;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  z-index: 9999;
  margin-top: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-list li {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dropdown-list li:hover {
  background: #f0f0f0;
}

.flag {
  width: 20px;
  height: 15px;
  margin-right: 8px;
  object-fit: cover;
}

/* Hide Google Translate banner and frame */
.goog-te-banner-frame {
  display: none !important;
}

body {
  top: 0 !important;
}

.skiptranslate {
  display: none !important;
}
</style>

<style>
/* Global styles to hide Google Translate UI elements */
.goog-te-banner-frame.skiptranslate {
  display: none !important;
}

body {
  top: 0px !important;
}

#google_translate_element {
  display: none !important;
}
</style>